/**
 * Utility for loading the data identified by the {@code dataset} to populate the list of
 * sites for the system.
 */
const d3fetch = require('d3-fetch');
const csv = require('csvtojson');

export default class DatasetLoader {

  /**
   * Perform the load. Note that this class supports non-temporal datasets only.
   */
  load(dataset) {

    // Confirm compatibility.
    if (dataset.type === 'msp1') {

      console.log('Loading MSP Dataset.');

      let url = dataset.url;

      if (typeof window === "undefined") {
        return csv().fromFile(url)
          .then((records) => {
            return this._transformRecords(dataset, records);
          })
          .catch(function (error) {
            console.error('Failed to load data: ' + error);
            return [];
          });
      }
      else {
        if (url.startsWith('./')) {
          url = window.location.origin +
            window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/')) +
            url.slice(1);
        }

        // Load the dataset CSV file, apply the multiplier/fudge factor, and return.
        return d3fetch.csv(url, {credentials: 'same-origin'})
          .then((records) => {
              return this._transformRecords(dataset, records);
            }
          )
          .catch(function (error) {
              console.error('Failed to load data: ' + error);
              return [];
            }
          );
      }

    } else {
      console.log(`Dataset "${dataset.type}" is not supported.`);
    }

  }

  /**
   * Utility function that maps the data from the underlying table structure to an object structure
   * expected by the application. This function ensures site uniqueness by transforming only the
   * first record for each site id.
   *
   * @return a Promise that resolves to an array of site data objects.
   */
  _transformRecords(dataset, records) {

    return new Promise((resolve /*, reject*/) => {

      let uniqueIds = {};
      const transformedData = records

      // Ensure the record is unique.
        .filter(record => {
          const id = record['LABEL_ID'];
          if (!uniqueIds[id]) {
            uniqueIds[id] = id;
            return true;
          } else {
            return false;
          }
        })

        // Transform the record.
        .map(function (record, index, records) {
          let transformedObj = {
            id: record['LABEL_ID'],
            name: record['LOC_NAME_S'],
            lon: record['LONGITUDE'],
            lat: record['LATITUDE'],
            isSelectable: (record['PotMonSite'] === "1"),
            isMustHave: (record['MustHave'] === "1"),
            index: index,
            data: {}
          };

          // Populate the data for each defined field.
          dataset.fields.forEach(function (field) {

            let value = record[field.fieldName];

            // Handle depending on the type of data.
            switch (field.type) {

              case 'numerical':
              default:
                // Ignore if this is the null value.
                if (!field.nullValue || field.nullValue !== +value) {

                  // Note the '+' forces JS to treat the value as a number.
                  transformedObj.data[field.fieldName] = +value;

                }
                if (field.nullValue === value) {
                  console.log(field.fieldName + ': ' + value + ' (null)');
                }
                break;

              case 'categorical':
                // Ignore if no value or only space(s).
                if (value) {
                  value = value.trim();
                }
                if (value && value.length > 0) {

                  // Add the value to the in-memory list of categories.
                  if (!field.categories) {
                    field.categories = [];
                  }
                  const exists = field.categories.find(category => {
                    return category.value === value;
                  });
                  if (!exists) {
                    field.categories.push({
                      id: value,
                      name: value,
                      value: value
                    });
                  }

                  // Include the value.
                  transformedObj.data[field.fieldName] = value;
                }
                break;
            }
          });
          return transformedObj;
        });

      // Resolve to the transformed data.
      resolve(transformedData);

    });
  }

}



// WEBPACK FOOTER //
// ./src/app/models/dataset-loader.js